import { ConsentSettingsButton } from "@/components/ConsentBanner";
import { Link } from "@tanstack/react-router";
import { THEME_PAGES } from "@/lib/themes-public";
import { THEME_DOT } from "./theme-ui";
import { PUBLIC_NAV } from "./PublicHeader";

/** The single Turkish site footer, in the homepage's editorial style. */
export function PublicFooter() {
  return (
    <footer className="border-t border-ink/10 bg-secondary text-ink">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 py-10 sm:px-8 md:grid-cols-[1.1fr_1fr_1fr] lg:py-12">
        <div className="min-w-0">
          <Link to="/" className="font-serif text-[22px] font-semibold leading-[0.95]">Akıllı<br />Sürdürülebilirlik</Link>
          <p className="mt-3 max-w-xs font-serif text-[15px] leading-snug text-ink/75">
            İnsan, teknoloji, ekonomi ve gezegenin kesişiminde daha iyi bir yarın için daha derin düşünmek.
          </p>
        </div>
        <nav aria-label="Temalar">
          <p className="text-[10px] uppercase tracking-[0.22em] text-ink/70">Temalar</p>
          <ul className="mt-3 space-y-1">
            {THEME_PAGES.map((t) => (
              <li key={t.key}>
                <Link to="/tema/$slug" params={{ slug: t.slug }} className="inline-flex min-h-9 items-center gap-2 font-serif text-[15px] hover:text-clay">
                  <span aria-hidden className={`size-2 rounded-full ${THEME_DOT[t.key]}`} />{t.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Site">
          <p className="text-[10px] uppercase tracking-[0.22em] text-ink/70">Site</p>
          <ul className="mt-3 grid grid-cols-2 gap-x-6 gap-y-1">
            {PUBLIC_NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="inline-flex min-h-9 items-center font-serif text-[15px] hover:text-clay">{n.label}</Link></li>
            ))}
            <li><Link to="/bulten" className="inline-flex min-h-9 items-center font-serif text-[15px] hover:text-clay">Bülten</Link></li>
            <li><Link to="/etiket" className="inline-flex min-h-9 items-center font-serif text-[15px] hover:text-clay">Etiketler</Link></li>
            <li><Link to="/dergi" className="inline-flex min-h-9 items-center font-serif text-[15px] hover:text-clay">Dergi</Link></li>
            <li><Link to="/podcast" className="inline-flex min-h-9 items-center font-serif text-[15px] hover:text-clay">Podcast</Link></li>
            <li><Link to="/raporlar" className="inline-flex min-h-9 items-center font-serif text-[15px] hover:text-clay">Raporlar</Link></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-ink/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-4 text-xs text-ink/70 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <span>© 2026 Arda Öztaşkın</span>
          <span className="flex flex-wrap items-center gap-5">
            <Link to="/privacy" className="hover:text-ink">Gizlilik</Link>
            <ConsentSettingsButton />
            <a href="/rss.xml" className="hover:text-ink">RSS</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
